
<div class="content">
    <p>
        Beachwatch issues water quality forecasts twice daily at 6 am and 1:30 pm to let you know if it is safe for swimming. 
        <br/><br/>
        Beachwatch model predicts pollution as Unlikely, Possible or Likely based on recent rainfall and other information available. 
        <br/><br/>
        Our forecasts may be updated during the day if conditions change.
    </p>
    
</div>
